module.exports = __webpack_public_path__ + "img/update-order.9bb9f394.png";